import { useRef } from 'react';

export const useDebounceHandler = (delay: number = 1000) => {
  const isBlocked = useRef(false);

  function debounceAction(cb: () => void) {
    if (isBlocked.current) return;

    isBlocked.current = true;

    cb();

    setTimeout(() => {
      isBlocked.current = false;
    }, delay);
  }

  return {
    debounceAction,
  };
};
